import { TFunction } from 'i18next';
import { GridEnrichedColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { ReceiptsRowViewModel } from '../../row/viewModel';
import { ReceiptsCellViewModel } from '../viewModel';
import { BenefitCell } from '../../../../partials/table';
import Util from '../../../../../misc/util';
import { ReceiptBenefitType } from '../../../../../viewModels/receipts';

export class BenefitCellViewModel extends ReceiptsCellViewModel {
  constructor(row: ReceiptsRowViewModel) {
    super(row);
  }

  get t() {
    return this.row.translate;
  }

  get cellValue() {
    return this.receipt.benefit;
  }

  get value() {
    return this.cellValue;
  }

  onClick() {
    this.receipt.openDetails();
  }

  static buildColDef(t: TFunction): GridEnrichedColDef {
    const valueOptions = Util.getKeys(ReceiptBenefitType).map((key) => ({
      label: t(`benefits:${ReceiptBenefitType[key]}`),
      value: ReceiptBenefitType[key]
    }));
    return {
      field: 'benefit',
      headerName: t('receipts:TYPE'),
      minWidth: 180,
      flex: 1,
      filterable: true,
      type: 'singleSelect',
      valueOptions: valueOptions,
      renderCell: (params: GridRenderCellParams<BenefitCellViewModel>) =>
        params.value && (
          <BenefitCell
            benefitKey={params.value?.cellValue}
            onClick={() => params.value?.onClick()}
          />
        )
    };
  }
}
